import dayjs from "dayjs";
import { TrainingSchedule } from "../entity/TrainingSchedule";

export interface TrainingScheduleValidationObj {
  name: boolean;
  startDate: boolean;
  endDate: boolean;
  active: boolean;
  canceledDays: boolean;
}

export const trainingScheduleValidationObjInit = {
  name: true,
  startDate: true,
  endDate: true,
  active: true,
  canceledDays: true,
};

export const validateTrainingSchedule = (
  t: TrainingSchedule
): TrainingScheduleValidationObj => {
  return {
    name: t.name.length > 0,
    startDate: dayjs(t.startDate, "YYYY-MM-DD", true).isValid(),
    endDate: dayjs(t.endDate, "YYYY-MM-DD", true).isValid(),
    active: true,
    canceledDays: true,
  };
};
